<template>
  <div ref="iconRef" :style="computedStyle" @click="handleClick">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import { useDraggable } from "@vueuse/core";
import type { CSSProperties } from "vue";
import clamp from "lodash-es/clamp";

const props = defineProps({
  onClick: {
    type: Function,
    default: () => {},
  },
});

const iconRef = ref<any>(null);
const moved = ref(false);

let startX = 0;
let startY = 0;

const { x, y } = useDraggable(iconRef, {
  initialValue: { x: startX, y: startY },
  preventDefault: true,

  onStart: () => {
    moved.value = false;
  },

  onEnd: (e) => {
    const { x, y } = e;
    moved.value = Math.abs(x - startX) > 20 || Math.abs(y - startY) > 20;
    startX = x;
    startY = y;
  },
});

const computedStyle = computed(() => {
  const left = clamp(x.value, 0, window.innerWidth - 48);
  const top = clamp(y.value, 0, window.innerHeight - 48);

  return {
    position: "absolute",
    touchAction: "none",
    cursor: "pointer",
    left: `${left}px`,
    top: `${top}px`,
  } as CSSProperties;
});

const handleClick = (e) => {
  if (!moved.value) {
    e.preventDefault();
    props.onClick();
  }
};
</script>
